function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(0 -1)",
  fill: "none"
}, React.createElement("path", {
  d: "M22.7 15a1 1 0 01-1-1.2c1.5-8.5-4-10.8-4-10.9a1 1 0 11.7-1.8s7 3 5.3 13c0 .5-.5.9-1 .9z",
  fill: "#805333"
}), React.createElement("path", {
  d: "M39.4 48.8A37 37 0 0136 32a39 39 0 013-16l-31.6.8C9.2 21.7 10 26.8 10 32a37 37 0 01-3.4 16.8z",
  fill: "#f9eab0"
}), React.createElement("path", {
  d: "M23 11s2-3 10-3c7.2 0 12 4.7 13 11.3a1 1 0 01-1.6 1 7.7 7.7 0 00-4.3-1.3c-1.7 0-3.5.6-4.8 1.7a1 1 0 01-1.3 0 7.6 7.6 0 00-5-1.7c-2 0-3.9.7-5.3 2.1a1 1 0 01-1.4 0 7.5 7.5 0 00-5.4-2.1c-1.7 0-3.5.6-4.9 1.7a1 1 0 01-1.3 0A7.6 7.6 0 006 19c-1.6 0-3 .4-4.3 1.3a1 1 0 01-1.6-1C1 12.7 5.8 8 13 8c8 0 10 3 10 3z",
  fill: "#e64c3c"
}), React.createElement("path", {
  d: "M6.2 16a1 1 0 01-.8-1.6A9.4 9.4 0 0113 11a1 1 0 010 2c-2.3-.1-4.5.9-6 2.6a1 1 0 01-.8.4z",
  fill: "#fb7b76"
}), React.createElement("path", {
  d: "M29 47c1.8 0 3.5-.6 4.9-1.7a1 1 0 011.2 0c1.4 1.1 3.1 1.7 4.9 1.7 1.4 0 2.8-.4 4-1.2a1 1 0 011.5 1.1C44.3 51.5 39.7 60 23 60S1.7 51.5.5 47A1 1 0 012 45.7a7.5 7.5 0 008.9-.5 1 1 0 011.2 0c1.4 1.1 3.1 1.7 4.9 1.7 2 0 3.9-.7 5.3-2.1a1 1 0 011.4 0A7.4 7.4 0 0029 47z",
  fill: "#e64c3c"
}), React.createElement("path", {
  d: "M14.2 42H14a1 1 0 01-.8-1.2 46.7 46.7 0 00.3-15.7 1 1 0 112-.2 50.5 50.5 0 01-.3 16.3c-.1.5-.5.8-1 .8zM31.8 42a1 1 0 01-1-.8 48.7 48.7 0 01-.3-16.3 1 1 0 112 .2 48.6 48.6 0 00.3 15.7 1 1 0 01-1 1.2z",
  fill: "#fac176"
}), React.createElement("g", {
  fill: "#805333"
}, React.createElement("path", {
  d: "M21 31a1 1 0 01-.7-.3l-1-1a1 1 0 011.4-1.4l1 1A1 1 0 0121 31zM20 36a1 1 0 01-.7-1.7l1-1a1 1 0 011.4 1.4l-1 1a1 1 0 01-.7.3zM26 36a1 1 0 01-.7-.3l-1-1a1 1 0 011.4-1.4l1 1A1 1 0 0126 36zM25 31a1 1 0 01-.7-1.7l1-1a1 1 0 011.4 1.4l-1 1a1 1 0 01-.7.3z"
})), React.createElement("circle", {
  cx: 17,
  cy: 12,
  fill: "#fb7b76",
  r: 1
}));

var SvgAppleCore = function SvgAppleCore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 46 59",
    width: 512,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAppleCore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple-core.84fc1b26.svg";
export { ForwardRef as ReactComponent };